﻿export default {
    //Hidden as per request in DNX-793
    hideContentSettings: true
}